import API from 'config/Axios';

export const ConfirmOrderPayment = (payload) => {
  return API.post(`/staff/payment-channel`, payload);
};
